module.exports = __webpack_public_path__ + "static/img/logodemo.82b9c7a5.png";